module.exports = __webpack_public_path__ + "img/plapla_slider_btn.b3859eb5.png";